/**
 * This is the version shown for the application about and in bug reports
 * Update the VERSION in it_api project to get the version correctly synced here
 */

// TO BE REPLACED BY THE VERSION UPDATER SCRIPT ON BUILD TIME (see IT_API version updater)
export const CURRENT_VERSION = '4444.4444.4444.4444';
